import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CookiePreferences from './CookiePreferences';
import './Footer.css';

const Footer = () => {
  const { t, i18n } = useTranslation();
  const [showCookiePreferences, setShowCookiePreferences] = useState(false);
  
  return (
    <>
      {showCookiePreferences && (
        <CookiePreferences onClose={() => setShowCookiePreferences(false)} />
      )}
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>{t('footer.about')}</h3>
          <p>{t('footer.aboutDescription')}</p>
        </div>
        
        <div className="footer-section">
          <h3>{t('footer.contact')}</h3>
          <ul>
            <li>{t('footer.contactEmail')}</li>
            <li>{t('footer.contactPhone')}</li>
            <li>{t('footer.contactAddress')}</li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h3>{t('footer.links')}</h3>
          <ul>
            <li><a href="#hero">{t('footer.home')}</a></li>
            <li><a href="#profiles">{t('footer.profiles')}</a></li>
            <li><a href="#qr-plate">{t('footer.products')}</a></li>
            <li><a href="#features">{t('footer.features')}</a></li>
            <li><a href={`/${i18n.language}/faq`}>{t('nav.faq')}</a></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h3>{t('footer.legal')}</h3>
          <ul>
            <li><a href="/privacy-policy">{t('agePolicy.privacyTitle')}</a></li>
            <li><a href="/terms-and-conditions">{t('footer.termsAndConditions')}</a></li>
            <li>
              <button 
                onClick={() => setShowCookiePreferences(true)}
                className="footer-cookie-link"
              >
                {t('footer.cookiePreferences', 'Cookie Preferences')}
              </button>
            </li>
          </ul>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>{t('footer.rights')}</p>
      </div>
    </footer>
    </>
  );
};

export default Footer;
